import { render, staticRenderFns } from "./BidLocationForm.vue?vue&type=template&id=58ab9396&"
import script from "./BidLocationForm.vue?vue&type=script&lang=js&"
export * from "./BidLocationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports